var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApyonLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260.89 238.43"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.33 71.38L70.66 37.51a2.28 2.28 0 011.26-4.25c14 .8 41.13 1.6 68.76-1.59 43-5 87.18-19.45 117.05-31.48a2.29 2.29 0 012 4.11L143.61 71.39a14.28 14.28 0 01-14.28-.01zm-10.18 18.34L3.44 22.5A2.27 2.27 0 00.9 26.26c25.37 19.85 59.48 51.05 85.32 85.86 16.58 22.33 29.44 46.21 35.76 58.74a2.28 2.28 0 004.31-1v-67.78a14.27 14.27 0 00-7.14-12.36zm28.29 12.46v134a2.28 2.28 0 004.53.31c4.51-31.89 14.11-77.19 31.34-117 11.05-25.52 25.3-48.6 33-60.34a2.28 2.28 0 00-3.05-3.22l-58.68 33.89a14.29 14.29 0 00-7.14 12.36z",
    fill: "#aaa",
    "data-name": "Ebene 1"
  }))));
}
export default SvgApyonLogo;